import MyAxios from "@/utilize/MyAxios";
import { useMutation } from "@tanstack/react-query";

interface IPayload {
  users: { id: string; roleId: string }[];
  region: string;
  country: string;
  name: string;
  displayName: string;
  industry: string;
}

const useCreateOrg = () => {
  return useMutation({
    mutationFn: (org: IPayload) =>
      MyAxios.post<{ id: string }>("/organizations", org),
  });
};

export default useCreateOrg;
